import React, {useState} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import {Inc,Owner,LotterySearchCondition} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Loading from './Loading';
import LotteryListSearch from './LotteryListSearch';
import Title from './Title';
import AppBank from './AppBank';

interface LotteryListProps {
	owner:Owner,
	bank:AppBank,
}
//let p:number = 1;

const LotteryList = (props:LotteryListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        lotterys:[],
        sum:0,
        isLoading:true,
        currentPage:1,
        pager:null,
        cond:Inc.defaultLotterySearchCondition(),
    });
    const search = (cond:LotterySearchCondition,page:number)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
            // if( first ){
            //     p = 1;
            // }
        window.scrollTo(0,0);
        Ajax.search("lottery/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({lotterys:res.lotterys,sum:res.sum,cond:cond,currentPage:page,pager:res.pager,isLoading:false});
            } else {
                setStates({...states,"isLoading":false});
            }
        });
    }
	const jump = (newPage:number)=>{
		//send(values,p);
		//p = newPage;
		search(states.cond,newPage);
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
		
	return (
		<div id="lottery_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="抽選受付履歴" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        ここにあなたが抽選販売した商品の受付がリアルタイムで表示されます。<br/>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>受注日時</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>抽選ID</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap} align='center' sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}>画像</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>商品名</TableCell>
									<TableCell className={classes.tableHeadNowrap} align='center' sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}>価格</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>個数</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>抽選結果</TableCell>
                                    </Hidden>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.lotterys.map( (lottery:any,index:number)=>{
                            const key = "lottery"+index;
                            let result_class = "";
                            if( lottery.lottery_result==="アタリ" ){
                                result_class = "cl cl-green";
                            } else if( lottery.lottery_result==="ハズレ" ){
                                result_class = "cl cl-black";
                            } else if( lottery.lottery_result==="抽選待ち" ){
                                result_class = "cl cl-orange";
                            } else {
                                result_class = "cl cl-red";
                            }
                            //let status_class;
                            //if( lottery.order_status_label==="キャンセル" ){
                            //    status_class = "cl cl-gray";
                            //} else if( lottery.order_status_label==="完了" ){
                            //    status_class = "cl cl-green";
                            //} else {
                            //    status_class = "cl cl-aqua";
                            //}
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellNowrap} style={{verticalAlign:"middle",width:'6em'}} align='center'>
                                        {lottery.order_date}<br/>
                                        {lottery.order_time}<br/>
                                    </TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} style={{width:'4em'}} align='center'>
                                            {lottery.plan_id}
                                        </TableCell>
                                    </Hidden>
									<TableCell className={classes.tableCellDense} style={{width:'80px'}} align='center' sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}><StoreImg owner_id={props.owner.owner_id} img_id={lottery.img_id} thumb={true} className="imgList"/></TableCell>
                                    <TableCell className={classes.tableCellDense}>
                                        <span className={classes.itemId}>ID:{lottery.item_id}</span><br/>
                                        {lottery.item_name}<br/>
                                        <Hidden smUp implementation="js">
                                            <Divider/>
                                            抽選ID:{lottery.plan_id}<br/>
                                            <span className={result_class}>{lottery.lottery_result}</span>
                                        </Hidden>
                                    </TableCell>
									<TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}} sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}>{lottery.price}円</TableCell>
                                    <TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}}>{lottery.su}</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} style={{width:'6em',textAlign:"center"}}>
                                            <span className={result_class}>{lottery.lottery_result}</span>
                                        </TableCell>
                                    </Hidden>
                                </TableRow>
                            );
                        })}

                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>合計</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap}></TableCell>
                                    </Hidden>
									<TableCell className={classes.tableCellNowrap} sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}></TableCell>
                                    <TableCell className={classes.tableCellDense}></TableCell>
                                    <TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}} sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}></TableCell>
                                    <TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}}>{states.sum}</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} style={{textAlign:"center"}}></TableCell>
                                    </Hidden>
                                </TableRow>


                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <LotteryListSearch update={search} bank={props.bank} bankKey={"savedLotteryListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default LotteryList;
